<template>
  <div flat tile class="visit-notes_card_medical-info">
    <div class="visit-notes_card_medical-info_header">
      <VisitNotesCardHeader
        id="patientInfo"
        :title="$t('visits.summary.medicalInformation')"
        @clear="clearMedicalInfoFields"
      />
    </div>
    <div class="visit-notes_card_medical-info_section1">
      <v-row no-gutters align="center" class="visit-notes_card_medical-info_allergies">
        <v-col cols="2">
          <span class="">{{ $t("visits.summary.allergies") }}</span>
        </v-col>
        <v-col cols="10">
          <Combobox
            :placeholder="$t('visits.notes.enterAllergies')"
            :items="medicalInfo.allergies"
            @change="onAllergiesChange"
          />
        </v-col>
      </v-row>
      <PatientHistoryTable
        id="PMH"
        place="visitNotes"
        :items="medicalInfo.pmh"
        @change="onPMHChange"
        tableClassName="ph-table_visit-notes_table"
      />
    </div>
    <div class="visit-notes_card_medical-info_section2">
      <PatientHistoryTable
        id="PSH"
        place="visitNotes"
        :items="medicalInfo.psh"
        @change="onPSHChange"
        tableClassName="ph-table_visit-notes_table"
      />
    </div>
    <div class="visit-notes_card_medical-info_section3">
      <MedicationTable
        place="visitNotes"
        :items="medicalInfo.medications"
        tableClassName="medications-table_visit-notes_table"
        @change="onMedicationsChange"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import MedicationTable from "@/components/Medications/Table";
import PatientHistoryTable from "@/components/PatientHistoryTable/Table";
import Combobox from "@/components/uikit/Combobox";
import { tableHeaders } from "@/utils/tableHeaders.ts";

import VisitNotesCardHeader from "./CardHeader.vue";

export default {
  name: "VisitNotesMedicalInfo",
  components: {
    PatientHistoryTable,
    MedicationTable,
    VisitNotesCardHeader,
    Combobox,
  },
  data: () => ({
    ...tableHeaders(),
  }),
  computed: {
    ...mapGetters("visitNote", ["medicalInfo"]),
  },
  methods: {
    ...mapMutations("visitNote", ["setMedicalInfoField"]),
    ...mapActions("visitNote", ["clearMedicalInfoFields", "autosave"]),
    onAllergiesChange(value) {
      this.setMedicalInfoField({ value, fieldName: "allergies" });
      this.autosave();
    },
    onMedicationsChange(value) {
      this.setMedicalInfoField({ value, fieldName: "medications" });
      this.autosave();
    },
    onPMHChange(value) {
      this.setMedicalInfoField({ value, fieldName: "pmh" });
      this.autosave();
    },
    onPSHChange(value) {
      this.setMedicalInfoField({ value, fieldName: "psh" });
      this.autosave();
    },
  },
};
</script>
